import { DefaultService } from '@/services/DefaultService';

export default class AssTabPrecoUsuarioService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAll(column, order, page, limit, situacao, id, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/tabpreco/asstabprecousuario.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idtabpreco=${id}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacao(AssTabPrecoUsuario) {
        return this._http.post(`${this._env}/ven/tabpreco/asstabprecousuario/updatesituacao`, AssTabPrecoUsuario, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociados(column, order, page, limit, id, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/tabpreco/asstabprecousuario/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idtabpreco=${id}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    save(lista) {
        return this._http.post(`${this._env}/ven/tabpreco/asstabprecousuario`, lista, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}